









































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import ExpressionEditor from "@/components/ExpressionEditor.vue";
import * as JQuery from "jquery";
import { Editor } from "../components/editor";
import { showKeyboard, AriaSpeaker, Heuristics, NavDirection, HorizontalDirection, HorizontalNavDirection } from 'semantic-math-editor';
import {createDemo} from "matheditor-demo";
import {toGRL} from "gradarius-client";
import { tag as gtag } from "@/components/tag";

@Component({
  components: { ExpressionEditor }
})
export default class EditorAbout extends Vue {
  symbols: string = "";
  meaning: string = "";

  demo: any;

  //for dev
  events: string[] = [];
  whatIsSelected: string = "";
  whatIsAroundCursor: string = "";
  json: string | null = null;
  internalRepr = "";
  latex = "";

  mounted() {
    const ee = this.$refs.a11y as ExpressionEditor;
    this.symbols = ee.getChararcterSpeech();
    this.meaning = ee.getSemanticSpeech();

    const edEl = document.getElementById("matharia");
    const graphEl = document.getElementById("structureTree");
    const semEl = document.getElementById("logicTree");

    if(!edEl || !graphEl || !semEl) return;
    
    const self = this;
    this.demo = createDemo(edEl, graphEl, semEl, function(
      h: string,
      mj: string,
      ml: string,
      l: string
    ) {
      self.showDefaultHelpMessage();
    });

    this.showDefaultHelpMessage();
    this.setSample("a^{(2)}");

    (<any>window).highlightOk = this.highlightOk;
    (<any>window).highlightError = this.highlightError;
    (<any>window).highlightStr = this.highlightStr;

    /////////// 06. FAQ  /////////////////////
    $(".faq-qus-title").on("click", function(this: any) {
      var $this = $(this);
      $this
        .toggleClass("active")
        .next()
        .slideToggle()
        .parent()
        .siblings()
        .children(".faq-qus-title")
        .removeClass("active")
        .next()
        .slideUp();
    });
  }

  highlightError(ids: number[], mes: string) {
    this.demo.highlight(ids, "error-frame");
    this.showHelpMessage(mes, "rgba(244, 67, 54, 0.9)");
  }

  highlightOk(ids: number[]) {
    this.demo.highlight(ids, "highlight-frame");
    this.showDefaultHelpMessage();
  }

  highlightStr(ids: number[]) {
    this.demo.highlight(ids, "highlight-gray");
  }

  setSample(tex: string) {
    this.demo.setSample(tex);
    this.demo.editor.focus();
  }

  showHelpMessage(mes: string, color: string) {
    const element = document.getElementById("help-message");
    if (element) {
      element.innerText = mes;
      element.style.color = color;
    }
  }

  showDefaultHelpMessage() {
    this.showHelpMessage(
      'Type "\\" to activate the context assistant',
      "rgb(108, 117, 125)"
    );
  }

  openVK() {
    showKeyboard(this.demo.editor);
  }

  validate(): void {
    const ee = this.$refs.badFormula as ExpressionEditor;
    ee.validate();
  }
  onUpdate(objects: string[]) {
    if (
      objects.indexOf("inputTree") >= 0 ||
      objects.indexOf("nonInputTree") >= 0
    ) {
      const ee = this.$refs.a11y as ExpressionEditor;
      this.symbols = ee.getChararcterSpeech();
      this.meaning = ee.getSemanticSpeech();
    }
  }

  //editor 4 dev

  private sleep = (milliseconds: number) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  };

  get editor(): Editor {
    const ee = this.$refs.editor as ExpressionEditor;
    return ee.editor;
  }

  insertSin() {
    this.editor.insertTrig("sin");
  }

  async assistDemo() {
    this.editor.ensureCursor();
    this.editor.lockUserInput();
    const advices = this.editor.getAdvices();
    this.editor.showAdviceBox(advices, true);
    await this.sleep(500);
    this.editor.hintListPopup.moveUpOrDown(false);
    await this.sleep(500);
    this.editor.hintListPopup.selectCurrent();
    this.editor.unlockUserInput();
  }

  async cursorDemo() {
    this.editor.ensureCursor();
    this.editor.lockUserInput();
    this.editor.navigate(HorizontalNavDirection.left);
    await this.sleep(500);
    this.editor.navigate(HorizontalNavDirection.left);
    await this.sleep(500);
    this.editor.navigate(HorizontalNavDirection.right);
    await this.sleep(500);
    this.editor.navigate(HorizontalNavDirection.right);
    this.editor.unlockUserInput();
  }

  async selectionDemo() {
    this.editor.ensureCursor();
    this.editor.lockUserInput();
    this.editor.navigate(HorizontalNavDirection.home);
    await this.sleep(500);
    this.editor.navigate(HorizontalNavDirection.right);
    await this.sleep(500);
    this.editor.navigate(HorizontalNavDirection.right);
    await this.sleep(500);
    this.editor.select(NavDirection.right);
    await this.sleep(500);
    this.editor.select(NavDirection.right);
    await this.sleep(500);
    this.editor.select(NavDirection.right);
    this.editor.unlockUserInput();
  }

  async undoDemo() {
    this.editor.ensureCursor();
    this.editor.navigate(HorizontalNavDirection.home);
    await this.sleep(500);
    this.editor.navigate(HorizontalNavDirection.right);
    await this.sleep(500);
    this.editor.deleteOneAtCursor(HorizontalDirection.right);
    await this.sleep(250);
    this.editor.deleteOneAtCursor(HorizontalDirection.right);

    await this.sleep(500);
    this.editor.undo();
    await this.sleep(500);
    this.editor.redo();
    await this.sleep(500);
    this.editor.undo();
    await this.sleep(500);
    this.editor.redo();
  }

  async copyDemo() {
    this.editor.ensureCursor();

    this.editor.navigate(HorizontalNavDirection.home);
    await this.sleep(500);
    this.editor.select(NavDirection.right);
    await this.sleep(500);
    this.editor.select(NavDirection.right);
    await this.sleep(500);
    this.editor.select(NavDirection.right);
    const copied = this.editor.copy();
    await this.sleep(500);
    this.editor.navigate(HorizontalNavDirection.right);
    await this.sleep(500);
    this.editor.paste(copied);
  }

  private getNodeLabel(node:any):string {
      return node.accept(AriaSpeaker.instance);
  }

  onUpdateDev(objects: string[]) {
    this.events = objects;
    const ee = this.$refs.editor2 as ExpressionEditor;
    const selection = ee.editor.getSelectionTree();
    if (selection) {
      this.whatIsSelected = toGRL(selection);
    } else {
      this.whatIsSelected = "nothing";
    }
    const cursor = ee.editor.getCursor();
    let s = "";
    if (cursor) {
      if (cursor.left) {
        let l_val: string | null = cursor.left.asString();
        if (l_val && l_val.trim().length === 0) {
          l_val = null;
        }
        s +=
          " at left: " +
          this.getNodeLabel(cursor.left.semanticNode) 
      } else {
        s += " at left: nothing";
      }
      if (cursor.right) {
        let r_val:string|null = cursor.right.asString();
        if (r_val && r_val.trim().length === 0) {
          r_val = null;
        }
        s +=
          " at right: " +
          this.getNodeLabel(cursor.right.semanticNode)
      } else {
        s += " at right: nothing";
      }
    } else {
      s = "nothing";
    }

    this.whatIsAroundCursor = s;
  }

  get lastEvents(): string {
    if (this.events) {
      return this.events.join(",");
    } else {
      return "no events";
    }
  }

  openVKDev() {
    const ee = this.$refs.editor2 as ExpressionEditor;
    ee.showMobileKeyboard();
  }

  validateDev() {
    const ee = this.$refs.editor3 as ExpressionEditor;
    ee.validate();
  }

  applyHeuristic() {
    const heuristics = Heuristics.getAll();
    const ee = this.$refs.editor4 as ExpressionEditor;
    ee.editor.heuristics = heuristics;
    ee.editor.applyHeuristics();
  }

  updateJson(objects: string[]) {
    console.log("aaa" + JSON.stringify(objects));
    if (
      objects.indexOf("inputTree") >= 0 ||
      objects.indexOf("nonInputTree") >= 0
    ) {
      const ee = this.$refs.editor5 as ExpressionEditor;
      this.json = JSON.stringify(ee.editor.getTree(), null, "\t");
      this.internalRepr = ee.editor.getInternal();
      this.latex = ee.editor.getTex();
    }
  }

   tag(a: string, c: string, l: string) {
    gtag(a, c, l);
  }
}
